'use strict';

const runInit = () => {
  if (typeof Swiper === 'undefined') return;

  const containers = document.querySelectorAll('.background-image-carousel .swiper-container');
  if (!containers.length) return;

  containers.forEach((el) => {
    const delay = parseInt(el.getAttribute('data-interval'), 10) || 5000;

    const hasMultipleRaw = el.getAttribute('data-has-multiple');
    const hasMultiple = hasMultipleRaw === 'true' || hasMultipleRaw === '1';
    const paginationEl = el.querySelector('.swiper-pagination');
    const nextEl = el.querySelector('.swiper-button-next');
    const prevEl = el.querySelector('.swiper-button-prev');
    // Si les flèches existent dans le DOM, activer la navigation (permet les clics)
    const hasNavElements = nextEl && prevEl;

    const options = {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 600,
      loop: true,
      autoplay: hasMultiple ? { delay, disableOnInteraction: false } : false,
      pagination: hasMultiple && paginationEl ? { el: paginationEl, clickable: true } : false,
      navigation: hasNavElements ? { nextEl, prevEl } : false
    };

    new Swiper(el, options);
  });
};

const init = () => {
  if (typeof Swiper !== 'undefined') {
    runInit();
    return;
  }
  // Swiper peut se charger plus tard (ex. : script dans le head en async) ; réessayer
  const check = setInterval(() => {
    if (typeof Swiper !== 'undefined') {
      clearInterval(check);
      runInit();
    }
  }, 100);
  setTimeout(() => clearInterval(check), 3000);
};

export default { init };
